var paperFeeTable = {
    true: {
        ELECTRONIC: {
            PAPER: "C",
            ELECTRONIC_AND_PAPER: "B",
        },
        ELECTRONIC_AND_PAPER: {
            ELECTRONIC: "A",
            PAPER: "C",
        },
        PAPER: {
            ELECTRONIC: "A",
        },
    },
    false: {
        ELECTRONIC: {
            PAPER: "F",
            ELECTRONIC_AND_PAPER: "D",
        },
        ELECTRONIC_AND_PAPER: {
            ELECTRONIC: "E",
        },
        PAPER: {
            ELECTRONIC: "E",
        },
    },
};
var getPaperFeeMessage = function (_a) {
    var _b, _c;
    var applicableFee = _a.applicableFee, currentEnrollment = _a.currentEnrollment, enrollmentOption = _a.enrollmentOption;
    var hasApplicableFee = applicableFee
        ? "true"
        : "false";
    return ((_c = (_b = paperFeeTable[hasApplicableFee][currentEnrollment]) === null || _b === void 0 ? void 0 : _b[enrollmentOption]) !== null && _c !== void 0 ? _c : "");
};
export default getPaperFeeMessage;
